import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AppHeaderComponent } from '../../global/appHeader/appHeader.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatProgressBarModule,
    AppHeaderComponent,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
})
export class ProfileComponent {
  profileCompletion = 78;
  user = {
    name: 'Name XYZ',
    organization: {
      name: 'Organization Name XYZ',
      type: 'Organization Type XYZ',
    },
    avatarUrl: 'https://via.placeholder.com/150',
  };
  constructor(
     private router: Router,
  ){}
  navigateBack(){
    this.router.navigate(['/projects'])
  }
}
